
import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';

import * as actions from '../actions';
import * as actionCreators from '../action-creators';
import { mergeMap } from 'rxjs/operators';
import { Actions } from '../../actions';

import * as users from '@webapp/sdk/users';
import store from '../../index';
import { StartLoading, CreateDialog } from '../../ui/action-creators';
import { DELETE_USER } from '../actions';


export const deleteUserEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, actionCreators.DeleteUser>(actions.DELETE_USER),
    mergeMap(async (action) => {
      return new CreateDialog(`REMOVE_USER`, {
        open: true,
        title: `Confirm Delete`,
        text: `Are you sure you want to delete this artist? This can't be undone.`,
        actions: [
          { type: "primary", label: "No", value: false },
          { type: "secondary", label: "Yes", value: true },
        ],
        callback: async (result) => {
          if (!result) {
            return;
          }

          store.dispatch(new StartLoading(DELETE_USER, true));

          try {
            await users.deleteProfile();

            return store.dispatch(new actionCreators.DeleteUserSuccess(action.user));
          } catch (err) {
            return store.dispatch(new actionCreators.DeleteUserError(err.message));
          }
        }
      })
    })
  );